import useSWR from "swr";
import { fetcher, fetcherBlob } from "../../../../utils/fetcher";
import { Context } from "../../../../context";
import { useContext, useEffect, useMemo, useRef } from "react";
import { useFormContext } from "react-hook-form";
import dayjs from "dayjs";

const Index = () => {
  const { setValue, watch } = useFormContext();
  const linkRef = useRef<HTMLAnchorElement>(null);
  const linkRefEn = useRef<HTMLAnchorElement>(null);
  const [data] = useContext(Context);
  const { token } = data;
  const { data: certifikat } = useSWR(
    `${process.env.REACT_APP_API_URL}/operateri/certifikat/preuzimanje`,
    (url: string) =>
      fetcherBlob(url, { headers: { Authorization: `Bearer ${token}` } })
  );

  const { data: certifikatPostoji } = useSWR(
    `${process.env.REACT_APP_API_URL}/operateri/csr`,
    (url: string) =>
      fetcher(url, { headers: { Authorization: `Bearer ${token}` } })
  );

  const { data: certifikatInfo } = useSWR(
    `${process.env.REACT_APP_API_URL}/operateri/certifikat`,
    (url: string) =>
      fetcher(url, { headers: { Authorization: `Bearer ${token}` } })
  );

  const url = useMemo(() => {
    if (!certifikat || linkRef.current === null) return "/";
    linkRef.current.download = "Javni kljuc.cer";
    // @ts-ignore
    return window.URL.createObjectURL(new File([certifikat], "CSR.cer"));
  }, [certifikat, certifikatPostoji]);

  const urlEn = useMemo(() => {
    if (!certifikat || linkRefEn.current === null) return "/";
    linkRefEn.current.download = "Public key.cer";
    // @ts-ignore
    return window.URL.createObjectURL(new File([certifikat], "CSR.cer"));
  }, [certifikat, certifikatPostoji]);

  useEffect(() => {
    setValue("certifikat", certifikat);
    setValue("certifikatPostoji", certifikatPostoji);
  }, [certifikat, certifikatPostoji]);

  if (!certifikatPostoji && (!certifikat || certifikat.size === 0)) return null;

  if (certifikatPostoji && (!certifikat || certifikat.size === 0))
    return (
      <p>
        CSR datoteka je prenesena. Čeka se potvrda CSR datoteke i izdavanje
        javnog ključa.
      </p>
    );

  return (
    <>
      <p>
        Ovdje možete preuzeti{" "}
        <a ref={linkRef} href={url}>
          Javni ključ.
        </a>
        (You can download{" "}
        <a ref={linkRefEn} href={urlEn}>
          Public key here.
        </a>
        )
      </p>
      {certifikatInfo && certifikatInfo.vrijediDo && (
        <p>
          Vrijedi do (Expires):{" "}
          <strong>
            {dayjs(certifikatInfo.vrijediDo).format("DD/MM/YYYY")}
          </strong>
        </p>
      )}
    </>
  );
};

export default Index;
